import React from "react";

const UnmaintainedBanner = () => (
  <div
    role="note"
    style={{
      background: "#fff8e1",
      border: "1px solid #f0d68b",
      borderRadius: 6,
      padding: "12px 16px",
      margin: "0 0 24px 0",
      fontFamily: "Georgia, serif",
      fontSize: "0.95em",
      lineHeight: 1.5,
      color: "#5a4a1a"
    }}
  >
    <strong>Heads up:</strong> this personal site is no longer actively
    maintained — content here may be out of date. For my current research,
    talks, teaching, and contact info, head to my{" "}
    <a href="/" style={{ color: "#9a6a00", fontWeight: 600 }}>
      academic page
    </a>
    . The latest writing lives on{" "}
    <a
      href="https://alexkrentsel.substack.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#9a6a00", fontWeight: 600 }}
    >
      Substack
    </a>
    .
  </div>
);

export default UnmaintainedBanner;
